(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/collections/results.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/collections/results.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
svs.numbergames.results.collections.Results = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.results.models.Result,
  comparator(a, b) {
    let sortOrder = b.get('drawNumber') - a.get('drawNumber');
    if (a.get('productId') === 'LOTTO') {
      const _a$get$split = a.get('regCloseTime').split('T'),
        _a$get$split2 = _slicedToArray(_a$get$split, 1),
        regCloseA = _a$get$split2[0],
        _b$get$split = b.get('regCloseTime').split('T'),
        _b$get$split2 = _slicedToArray(_b$get$split, 1),
        regCloseB = _b$get$split2[0],
        _regCloseA$split = regCloseA.split('-'),
        _regCloseA$split2 = _slicedToArray(_regCloseA$split, 3),
        ay = _regCloseA$split2[0],
        am = _regCloseA$split2[1],
        ad = _regCloseA$split2[2],
        _regCloseB$split = regCloseB.split('-'),
        _regCloseB$split2 = _slicedToArray(_regCloseB$split, 3),
        by = _regCloseB$split2[0],
        bm = _regCloseB$split2[1],
        bd = _regCloseB$split2[2],
        sortByYear = by - ay,
        sortByMonth = bm - am,
        sortByDate = bd - ad;
      sortOrder = sortByYear || sortByMonth || sortByDate;
    }
    return sortOrder;
  },
  fetchResultByDraw(draw) {
    let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      context = _ref.context,
      success = _ref.success;
    if (!draw) return;
    const model = this.getResultByDraw(draw);
    if (model) {
      if (typeof success === 'function') success.call(context, model);
    } else {
      this.create({
        productDrawId: draw.productDrawId,
        drawNumber: draw.drawNumber,
        addonDrawId: draw.addonDrawId,
        addonDrawNumber: draw.addonDrawNumber
      }, {
        wait: true,
        context,
        success
      });
    }
  },
  getResultByDraw() {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      productDrawId = _ref2.productDrawId,
      drawNumber = _ref2.drawNumber;
    return this.findWhere({
      productDrawId,
      drawNumber
    });
  }
});

 })(window);